import { useState, useEffect } from 'react';
import { X } from 'lucide-react';

export default function CookieBanner() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const accepted = localStorage.getItem('larae_cookies_accepted');
    if (!accepted) setTimeout(() => setShow(true), 1500);
  }, []);
  const accept = () => { localStorage.setItem('larae_cookies_accepted', '1'); setShow(false); };
  if (!show) return null;
  return (
    <div data-testid="cookie-banner" className="fixed inset-x-3 bottom-24 md:bottom-5 md:left-5 md:right-auto md:max-w-md z-40 bg-white rounded-2xl shadow-2xl border border-sand p-5">
      <button onClick={() => setShow(false)} aria-label="Close" className="absolute top-3 right-3 text-ink/40 hover:text-ink"><X size={18} /></button>
      <h4 className="font-outfit text-base font-semibold text-ink mb-1.5">We use cookies</h4>
      <p className="font-manrope text-sm text-ink/70 leading-relaxed">
        We use essential cookies to make the site work and analytics cookies to improve it.
      </p>
      <div className="flex gap-2 mt-4">
        <button data-testid="cookie-accept" onClick={accept} className="flex-1 bg-forest text-white text-sm font-medium rounded-full px-4 py-2.5 hover:bg-forest/90">Accept</button>
        <a href="/privacy" className="flex-1 text-center bg-sand text-ink text-sm font-medium rounded-full px-4 py-2.5 hover:bg-oat">Learn more</a>
      </div>
    </div>
  );
}
